import type { ItemDto } from '@wishare/shared';

/**
 * Состояние желания глазами дарителя: разобрано оно или в него ещё можно войти.
 *
 * Правило одно и живёт на сервере (routes/reservations.ts): у складчины
 * ограничение по количеству снято, присоединиться можно всегда, пока подарок
 * не куплен. Подарок при этом один, поэтому остаток штук у складчины
 * обнуляется от первого же участника — считать по нему «разобрано» нельзя.
 *
 * Отдельный модуль, а не копия условия в каждом месте: до этого карточка и
 * отбор считали признак каждый сам, и оба считали неверно — карточка гасла,
 * а из «Свободных» складчина пропадала, хотя кнопка «Скинуться» оставалась
 * рабочей.
 */

/** Разобрано ли желание полностью — то есть взять его уже нельзя. */
export function isFullyTaken(item: ItemDto): boolean {
  if (!item.reservation) return false;
  if (item.groupGift) return false;
  return item.reservation.remaining === 0;
}
